import { render, staticRenderFns } from "./pagination-tertiary.vue?vue&type=template&id=6b97ebf8&scoped=true"
import script from "./pagination-tertiary.vue?vue&type=script&lang=js"
export * from "./pagination-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97ebf8",
  null
  
)

export default component.exports